module.exports = __webpack_public_path__ + "img/05.fc3cab86.png";